import { render, staticRenderFns } from "./MerchantStory.vue?vue&type=template&id=445417c2&scoped=true&"
import script from "./MerchantStory.vue?vue&type=script&lang=js&"
export * from "./MerchantStory.vue?vue&type=script&lang=js&"
import style0 from "./MerchantStory.vue?vue&type=style&index=0&id=445417c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445417c2",
  null
  
)

export default component.exports